var _rect, _path, _path2, _path3, _path4, _g, _path5, _rect2, _rect3, _rect4, _rect5, _path6, _path7, _path8, _rect6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlideshow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 153,
    viewBox: "0 0 304 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(0 1)",
    fill: "#A5B0B7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4500_82579)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 12.6436H232V102.644H72V12.6436Z",
    fill: "#4C6170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228 16.6436H76V98.6436H228V16.6436ZM72 12.6436V102.644H232V12.6436H72Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4500_82579",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 33,
    width: 193,
    height: 97
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.159 33.7227L199.807 109.713H60.5109L130.159 33.7227Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.352 53.9866L253 129.977H113.704L183.352 53.9866Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4500_82579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.9999,
    y: -4.35645,
    width: 148,
    height: 99,
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145 94.5527L189.372 45.1528L192.348 47.8257L147.976 97.2257L145 94.5527Z",
    fill: "#4C6170"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112.644,
    width: 30,
    height: 5,
    fill: "#4C6170"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 112.644,
    width: 15,
    height: 5,
    fill: "#4C6170"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 112.644,
    width: 15,
    height: 5,
    fill: "#4C6170"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 112.644,
    width: 15,
    height: 5,
    fill: "#4C6170"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.549 115.26L178.927 119.768L169.462 132.23L159.549 115.26Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.818 121.695L183.538 130.289L181.039 133.579L169.319 124.985L171.818 121.695Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156 112.644L181.945 118.679L177.906 123.996L186 129.931L181.39 136L173.296 130.065L169.272 135.364L156 112.644ZM172.945 127.644L181.039 133.579L183.538 130.289L175.444 124.354L178.927 119.768L159.549 115.26L169.462 132.23L172.945 127.644Z",
    fill: "#4C6170"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 144,
    width: 304,
    height: 9,
    fill: "#9B1926"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4500_82579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 117,
    fill: "white",
    transform: "translate(72 0.643555)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideshow);
export default __webpack_public_path__ + "static/media/slideshow.4d1e5c64a6710c20d6568ff6c15f2532.svg";
export { ForwardRef as ReactComponent };